import React, { Component } from 'react';
import './AboutPage.scss';

export class About extends Component {

    render() {
        return (
            <div className='About'>
                <div className='row'>
                    <div className='modal column small-10 small-centered  '>
                        <br />
                        <div className='row'>
                            { this.renderContent() }
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        );
    }

    renderContent() {
        return (
            <div className='column small-11 small-centered'>
                <h1>{ 'About' }</h1>
                <hr />
                <div className='about-text'>
                    <h2>{ 'This is a site for practicing German through both programmatically-generated and manually-declared exercises.' }</h2>
                    <br /><br />
                    <h2>{ 'The adjective declension exercises are randomly generated by a German language data model, so the sentences may not make sense despite being grammatically correct.' }</h2>
                    <br /><br />
                    <h2>{ 'The sentences for the all other exercises have been gathered from various sources, including German newspapers, zines, books, and websites.' }</h2>
                    <br /><br />
                    <h3>
                        <span>{ 'Learn more about how this works by looking at ' }</span>
                        <a href='https://github.com/whroman/decline/blob/gh-pages/README.md'>
                            { 'the open-source codebase of this project' }
                        </a>
                        <span>{ '.' }</span>
                    </h3>
                    <br /><br />
                    <span>{ 'The daily background image is a random image taken in the last 48 hours by a NASA rover on Mars. Credit goes to ' }</span>
                    <a href="https://api.nasa.gov/api.html#MarsPhotos">{ 'NASA\'s awesome RESTful API' }</a>
                    <span>{ '.' }</span>
                    <br /><br />
                    <span>{ 'Questions? Comments? Feedback? Send a note to ' }</span>
                    <a href='mailto:me@walterroman.com'>{ 'me@walterroman.com' }</a>
                    <span>{ '.' }</span>
                </div>
            </div>
        );
    }

}

export default About;



/** WEBPACK FOOTER **
 ** ./app/components/pages/About/AboutPage.js
 **/